import React, { useState, useEffect } from "react";
import { db } from "../config/firebase-config"; // Adjust the import path as necessary
import MessageModal from "./MessageModal";
import { collection, addDoc } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import { FaUser, FaBriefcase, FaEnvelope, FaPhone, FaCommentAlt, FaCalendarCheck } from "react-icons/fa";
import CalendlyEmbed from "./CalendlyEmbed";
import "./ContactForm.css"
const ContactForm = () => {
  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setErrorMessage("");

    try {
      const docRef = await addDoc(collection(db, "contactForm"), {
        name,
        position,
        number,
        message,
        email,
        timestamp: new Date()
      });
      console.log("Document written with ID: ", docRef.id);

      // Reset the form and show the modal
      setName("");
      setPosition("");
      setNumber("");
      setMessage("");
      setEmail("");
      setModalMessage("Thank you for your request. We will contact you soon regarding your inquiry.");
      setShowModal(true);
    } catch (e) {
      console.error("Error adding document: ", e);
      setErrorMessage("There was an error submitting your request. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/"); // Navigate to home page
  };

  const calendlyPrefill = {
    ...(name && { name }),
    ...(email && { email }),
  };

  return (
    <div className="contact-form-container">
      <div className="contact-form-wrapper">
        <div className="contact-form">
          <h2>Get In Touch</h2>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          <form onSubmit={handleSubmit}>
            <div className="contact-flex-container">
              <div className="contact-flex-item input-group">
                <label htmlFor="name">
                  <FaUser className="input-icon" /> Full Name*
                </label>
                <input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  required
                />
              </div>
              <div className="contact-flex-item input-group">
                <label htmlFor="position">
                  <FaBriefcase className="input-icon" /> Position*
                </label>
                <input
                  id="position"
                  type="text"
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                  placeholder="Principal, Teacher, Parent"
                  required
                />
              </div>
            </div>

            <div className="contact-flex-container">
              <div className="contact-flex-item input-group">
                <label htmlFor="email">
                  <FaEnvelope className="input-icon" /> Email Address*
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your.email@example.com"
                  required
                />
              </div>

              <div className="contact-flex-item input-group">
                <label htmlFor="phone">
                  <FaPhone className="input-icon" /> Phone Number
                </label>
                <input
                  id="phone"
                  type="tel"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                  placeholder="+1(123) 456-7890"
                />
              </div>
            </div>

            <div className="textarea-group input-group">
              <label htmlFor="message">
                <FaCommentAlt className="input-icon" /> Message
              </label>
              <textarea
                id="message"
                value={message}
                placeholder="Please outline your request or inquiry here..."
                onChange={(e) => setMessage(e.target.value)}
                rows="5"
              />
            </div>
            <button 
              type="submit" 
              disabled={submitting}
            >
              {submitting ? "Sending..." : "Submit Request"}
            </button>
          </form>
        </div>

        <section className="calendly-section" id="book-meeting">
          <div className="calendly-card">
            <h2 className="calendly-heading">
              <FaCalendarCheck className="calendly-heading-icon" />
              Book a 1:1 Meeting
            </h2>
            <p className="calendly-subheading">
              Choose a time that works for you. We’ll collect your name, email, and a few details.
            </p>
            <CalendlyEmbed prefill={calendlyPrefill} resize />
          </div>
        </section>
      </div>
      <MessageModal
        isOpen={showModal}
        onClose={handleCloseModal}
        message={modalMessage}
      />
    </div>
  );
};

export default ContactForm;